module.exports = __webpack_public_path__ + "static/media/sleet.772901e9.ico";